import styled from 'styled-components'

export const Loader = styled.div`
  width: 32px;
  height: 32px;
  margin: 20vh auto;
  border: 3px solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: spin 700ms linear infinite;

  @keyframes spin { to { transform: rotate(360deg); } }
`
